import { render, staticRenderFns } from "./ContestViewComponent.vue?vue&type=template&id=774d3df2"
import script from "./ContestViewComponent.vue?vue&type=script&lang=js"
export * from "./ContestViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports